import { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';
import { fetchContainersSaga } from './workers';
import { fetchContainersAction } from '../reducer';

export default function* watcherContainers(): SagaIterator {
  yield takeEvery(fetchContainersAction, fetchContainersSaga);
}
